/**
 * Checks if a filename has an allowed extension
 * @param fileName - The name of the file to check
 * @param allowedExtensions - List of allowed extensions (without leading dot)
 * @returns Object with isValid boolean and normalizedExtension string
 */
export const validateFileExtension = (fileName: string, allowedExtensions: string[]): { isValid: boolean; normalizedExtension: string } => {
  // Default result with invalid status
  const result = { isValid: false, normalizedExtension: '' };

  if (!fileName || !allowedExtensions || allowedExtensions.length === 0) {
    return result;
  }

  // Get the file extension (everything after the last dot)
  const extensionMatch = RegExp(/\.([^.]+)$/).exec(fileName);
  if (!extensionMatch) {
    return result;
  }

  // Extract the extension (keeping original case)
  const fileExtension = extensionMatch[1];
  result.normalizedExtension = fileExtension;

  // Check if the extension is in the allowed list (case-insensitive comparison)
  const cleanedAllowedExtensions = allowedExtensions.map((ext) => ext.replace(/^\./, '').toLowerCase());
  const fileExtensionLower = fileExtension.toLowerCase();

  // Perform a case-insensitive comparison
  result.isValid = cleanedAllowedExtensions.includes(fileExtensionLower);

  return result;
};
